<template>
  <main-layout>
    <v-container>
      <h1 class="mb-3">{{ $t('branches_management') }}</h1>

      <BranchForm v-if="isFormOpen" @cancel="isFormOpen = false" @submit="handleFormSubmit" />
      <template v-else>
        <div :style="{ margin: '-0.25rem' }">
          <v-layout wrap justify-end>
            <v-flex shrink class="pa-1">
              <v-btn color="primary" class="ma-0" @click="isSearchOpen = !isSearchOpen">
                <v-icon>search</v-icon>
                {{ $t('Search') }}
                <v-icon v-if="!isSearchOpen">expand_more</v-icon>
                <v-icon v-else>expand_less</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>

        <BranchSearch
          v-if="isSearchOpen"
          v-model="filter"
          class="mt-3"
          @input="isSearchOpen = false"
        />

        <v-btn
          v-if="!isSearchOpen"
          block
          outline
          large
          color="primary"
          class="mt-3 mx-0 mb-0"
          :style="{ borderStyle: 'dashed', height: '64px' }"
          @click="isFormOpen = true"
        >
          <v-icon>add</v-icon>
          {{ $t('branch_add') }}
        </v-btn>
      </template>

      <div class="mt-5" :style="{ margin: '-0.25rem' }">
        <v-layout wrap justify-end>
          <v-flex shrink class="pa-1">
            <v-btn outline color="grey" class="ma-0" @click="exportData">
              <v-icon>ios_share</v-icon>
              {{ $t('export') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </div>

      <div class="mt-3">
        <v-pagination
          v-if="total > 0"
          :value="filter.page"
          :length="totalPages"
          class="mb-2"
          @input="filter = { ...filter, page: $event }"
        />
        <div v-if="isLoading" class="d-flex justify-center align-center">
          <v-progress-circular color="primary" indeterminate />
        </div>
        <div v-else-if="!isLoading && total > 0" class="branch-list">
          <BranchItem
            v-for="item in items"
            :key="item.id"
            :value="item"
            @activeChange="handleActiveChange"
            @edit="handleEdit"
            @delete="handleDelete"
          />
        </div>
        <p v-else class="mb-0 text-xs-center">{{ $t('no_data') }}</p>
        <v-pagination
          v-if="total > 0"
          :value="filter.page"
          :length="totalPages"
          class="mt-2"
          @input="filter = { ...filter, page: $event }"
        />
      </div>
    </v-container>
  </main-layout>
</template>

<script>
import BranchSearch from './Search.vue'
import BranchForm from './Form.vue'
import BranchItem from './Item.vue'
import superrichApi from '@/api/superrich'
import { mapGetters } from 'vuex'
import multiselect from 'vue-multiselect'

export default {
  components: { BranchSearch, BranchForm, BranchItem, multiselect },
  data() {
    return {
      items: [],
      total: 0,
      filter: {
        page: 1,
        limit: 10
      },
      isLoading: true,
      isSearchOpen: false,
      isFormOpen: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    totalPages() {
      return Math.ceil(this.total / this.filter.limit)
    }
  },
  watch: {
    filter: {
      immediate: true,
      handler() {
        this.fetchItems()
      }
    }
  },
  methods: {
    async fetchItems() {
      try {
        this.isLoading = true

        const response = await superrichApi.getBranches({
          page_id: this.selectedBot.pageid,
          limit: this.filter.limit,
          offset: (this.filter.page - 1) * this.filter.limit,
          sort_by: 'created_at',
          sort_type: 'desc',
          branch_name: this.filter.branchName,
          phone_number: this.filter.phoneNumber,
          subdistrict: this.filter.subdistrict,
          district: this.filter.district,
          province: this.filter.province,
          postcode: this.filter.postcode,
          latitude: this.filter.latitude,
          longitude: this.filter.longitude
        })

        if (response.status === 200 && response.data.data) {
          this.items = response.data.data
          this.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    exportData() {},
    handleFormSubmit(value) {
      console.log(value)
    },
    async handleActiveChange(item, value, { setIsActive, setIsActiveLoading }) {
      try {
        setIsActiveLoading(true)

        await superrichApi.putBranch({
          page_id: this.selectedBot.pageid,
          id: item.id,
          is_used: value
        })
      } catch (error) {
        console.error(error)
        setIsActive(item.is_used)
      } finally {
        setIsActiveLoading(false)
      }
    },
    handleEdit() {
      this.isFormOpen = true
    },
    async handleDelete() {
      const { value: isConfirmed } = await this.$swal({
        title: this.$t('branch_delete_question', { name: 'Sample text' }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (isConfirmed) {
        console.log('delete')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.branch-list {
  > *:not(:first-child) {
    margin-top: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/superrich/branch/Branch.vue